import React from 'react'
import Anime from '../../components/Anime/Anime'

const Logo = () =>
  <div className="flex flex-column items-center">
    <svg
      className="mv2"
      style={{ overflow: 'visible' }}
      width="85"
      height="15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="#FFF" fillRule="evenodd">
        <Anime
          scaleX={[0, 1]}
          elasticity="300"
          scaleY={[1.5, 1]}
          translateY={['-30px', 0]}
          opacity={[0, 1]}
          duration="1000"
          delay={(target, i) => i * 100 + 400}
        >
          <path
            className="transform-origin-center"
            d="M6.397 4.785c-.42-.75-.945-1.07-1.703-1.012-.958.075-1.476.636-1.42 1.354.025.34.21.927 1.234 1.188l1.762.466c1.762.47 3.462 1.18 3.652 3.65.186 2.4-1.5 4.23-4.29 4.45-2.314.18-4.068-.71-4.8-2.4-.344-.81.094-1.89 1.19-1.97.66-.05 1.146.28 1.442 1 .295.7.886 1.078 1.903 1 1.217-.096 1.81-.724 1.75-1.52-.045-.56-.327-1.1-1.208-1.332l-2.12-.58C1.74 8.5.62 7.44.47 5.548.32 3.51 1.78 1.59 4.51 1.38c2.136-.164 3.787.69 4.47 2.263.393.913-.136 1.876-1.172 1.956-.638.05-1.128-.32-1.407-.82"
          />
          <path
            className="transform-origin-center"
            d="M14.13 10.463c.142.754.646 1.187 1.405 1.146.86-.05 1.327-.66 1.276-1.6l-.43-7.89c-.04-.86.5-1.45 1.36-1.5.86-.05 1.49.48 1.54 1.33l.44 7.95c.14 2.492-1.49 4.15-4.03 4.29-2.44.13-4.11-1.18-4.41-3.448-.1-.757.48-1.51 1.32-1.556.838-.045 1.43.504 1.55 1.26"
          />
          <path
            className="transform-origin-center"
            d="M25.536 8.17l.09 2.78 4.318-.143c.76-.026 1.297.498 1.322 1.258.025.76-.477 1.316-1.236 1.34l-5.797.19c-.86.03-1.437-.513-1.466-1.372L22.43 1.93c-.03-.86.512-1.44 1.372-1.467L29.398.28c.76-.026 1.297.477 1.322 1.237.025.758-.476 1.336-1.236 1.36l-4.118.136.086 2.598 3.538-.11c.76-.02 1.276.5 1.302 1.26.024.76-.46 1.28-1.218 1.3l-3.538.12z"
          />
          <path
            className="transform-origin-center"
            d="M39.905 5.694l2.896 5.553c.11.2.15.398.15.62.01.8-.64 1.466-1.46 1.473-.66.007-1.16-.468-1.39-.925l-2.11-4.182-1.5 2.196.02 1.54c.01.86-.58 1.42-1.44 1.43-.86.01-1.45-.55-1.46-1.41l-.1-10.5C33.5.63 34.06.07 34.916.06c.86-.01 1.486.54 1.495 1.4l.043 4.56L39.856.65c.252-.4.692-.644 1.172-.65.76-.007 1.384.607 1.392 1.368.003.26-.076.52-.194.7L39.9 5.694z"
          />
          <path
            className="transform-origin-center"
            d="M51.542 5.776l2.76 5.622c.096.202.134.402.13.622-.01.8-.68 1.45-1.5 1.44-.66-.01-1.155-.498-1.368-.96l-2-4.232-1.55 2.158-.024 1.54c-.012.86-.62 1.413-1.48 1.4-.86-.012-1.433-.58-1.42-1.442l.152-10.502c.013-.86.58-1.412 1.44-1.4.86.014 1.473.582 1.46 1.443l-.066 4.56 3.538-5.29c.267-.396.71-.63 1.19-.623.76.01 1.372.64 1.36 1.4-.003.26-.087.52-.21.698l-2.412 3.566z"
          />
          <path
            className="transform-origin-center"
            d="M63.357 9.387c-.056 1.18.608 1.95 1.767 2.006 1.158.055 1.892-.65 1.948-1.83l.213-4.494c.055-1.18-.61-1.95-1.767-2.01-1.158-.06-1.892.65-1.948 1.83l-.213 4.49zm6.608.373c-.13 2.736-2.128 4.363-4.964 4.23-2.83-.134-4.67-1.943-4.54-4.68l.22-4.614C60.81 1.96 62.53.32 65.65.466c2.837.136 4.674 1.944 4.544 4.68l-.22 4.614z"
          />
          <path
            className="transform-origin-center"
            d="M78.393 6.71l2.8-4.224c.36-.535.867-.88 1.625-.822.838.063 1.354.662 1.29 1.52l-.782 10.55c-.06.797-.738 1.288-1.535 1.23-.79-.06-1.33-.642-1.27-1.44l.46-6.14-1.58 2.368c-.29.42-.67.69-1.31.645-.64-.048-.99-.375-1.2-.812L75.6 6.902l-.466 6.284c-.055.757-.692 1.23-1.45 1.174-.76-.055-1.3-.618-1.24-1.376l.786-10.61c.064-.856.663-1.374 1.5-1.31.78.057 1.21.47 1.487 1.05L78.4 6.71z"
          />
        </Anime>
      </g>
    </svg>
    <svg
      className="mv2"
      style={{ overflow: 'visible' }}
      width="243"
      height="59"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="#3B1A4F" fillRule="evenodd" opacity=".9">
        <Anime
          scaleX={[0, 1]}
          elasticity="600"
          scaleY={[2, 1]}
          translateY={['-20px', 0]}
          opacity={[0, 1]}
          duration="1000"
          delay={(target, i) => i * 100 + 1200}
        >
          <path
            className="transform-origin-center"
            d="M14.39 38.768l2.206 10.766 6.65-1.364c3.773-.773 5.41-3.252 4.72-6.61-.646-3.155-3.29-4.9-6.925-4.155l-6.65 1.363zm-3.738-18.24l2.065 10.08 5.966-1.223c3.36-.69 5.12-2.908 4.432-6.267-.674-3.292-3.138-4.502-6.497-3.814l-5.966 1.223zM.13 19.398c-.604-2.95.923-5.265 3.87-5.87L16.345 11c8.366-1.714 15.233 1.81 16.71 9.008.997 4.87-.592 8.625-4.354 11.182l.02.068c5.15.732 8.59 3.887 9.66 9.098 1.59 7.748-3.32 13.758-11.69 15.472l-13.44 2.754c-2.95.604-5.26-.92-5.86-3.87L.13 19.396z"
          />
          <path
            className="transform-origin-center"
            d="M55.95 33.877l9.245-1.103-6.638-16.055-2.607 17.15zm24.022 9.33c.34 2.85-1.193 5.36-4.042 5.7-2.642.314-4.58-1.147-5.47-3.296l-1.97-4.7-13.9 1.66-.732 5.09c-.3 2.22-1.908 4.11-4.48 4.41-2.918.35-4.566-1.64-4.88-4.28-.04-.35-.038-.91.096-1.56l6.69-36.11c.602-3.24 2.855-5.62 6.12-6.01 3.27-.39 6.02 1.4 7.364 4.41l14.72 33c.3.74.443 1.36.484 1.71z"
          />
          <path
            className="transform-origin-center"
            d="M96.14 10.153l.415 11.893 5.736-.2c4.13-.144 6.57-2.54 6.44-6.25-.12-3.567-2.72-5.788-6.85-5.644l-5.73.2zm22.48 29.965c.15.346.316 1.04.335 1.6.1 2.798-2.27 5.193-5.07 5.29-2.1.073-3.965-1.262-4.87-3.123l-6.204-13.162-5.94.207.41 11.684c.11 3.01-1.92 5.04-4.93 5.146-3.01.105-5.1-1.783-5.21-4.792l-1.27-36.38c-.1-3.007 1.79-5.035 4.8-5.14l12.04-.42c9.17-.32 16.09 5.253 16.39 13.998.21 5.807-2.23 10.305-6.34 12.97l5.89 12.122z"
          />
          <path
            className="transform-origin-center"
            d="M160.454 43.614c-.155 3.006-2.145 4.865-5.15 4.71-2.097-.108-3.787-1.317-4.675-3.115l-12.06-24.39-1.15 22.09c-.14 2.65-2.19 4.37-4.85 4.23-2.66-.14-4.52-2.06-4.39-4.72l1.92-37.19c.15-3.01 2.35-4.86 5.36-4.7 2.23.11 3.8 1.04 5 3.48l11.55 23.3 1.11-21.39c.136-2.66 2.12-4.38 4.774-4.24 2.657.13 4.59 2.06 4.453 4.71l-1.914 37.2z"
          />
          <path
            className="transform-origin-center"
            d="M182.54 31.938l-1.305 9.643 14.984 2.03c2.63.36 4.18 2.48 3.82 5.11-.36 2.64-2.42 4.27-5.05 3.91l-20.12-2.72c-2.99-.4-4.66-2.61-4.26-5.59l4.83-35.72c.4-2.98 2.61-4.66 5.59-4.25l19.43 2.62c2.63.36 4.19 2.41 3.84 5.04-.36 2.64-2.43 4.34-5.06 3.98l-14.29-1.93-1.22 9.02 12.28 1.66c2.63.36 4.11 2.47 3.75 5.1-.36 2.64-2.33 4.14-4.96 3.78l-12.28-1.66z"
          />
          <path
            className="transform-origin-center"
            d="M216.842 9.77l22.462 4.76c2.602.552 3.976 2.846 3.426 5.45-.552 2.6-2.71 4.005-5.312 3.452l-6.232-1.32-6.69 31.57c-.624 2.945-3.085 4.427-6.03 3.803-2.944-.623-4.523-2.962-3.9-5.906l6.69-31.58-6.3-1.34c-2.602-.55-3.99-2.78-3.44-5.38.552-2.6 2.723-4.08 5.326-3.53"
          />
        </Anime>
      </g>
    </svg>

    <svg
      className="mb2 mt1"
      style={{ overflow: 'visible' }}
      width="195"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="#FFF" fillRule="evenodd">
        <Anime
          scaleX={[0, 1]}
          elasticity="300"
          scaleY={[1.5, 1]}
          translateY={['-20px', 0]}
          opacity={[0, 1]}
          duration="1000"
          delay={(target, i) => i * 50 + 1800}
        >
          <path
            className="transform-origin-center"
            d="M3.23 12.38l1.503 7.798 1.768-.34c1.24-.24 1.79-1.1 1.55-2.355l-.74-3.83c-.24-1.256-1.07-1.85-2.3-1.612l-1.77.34zm6.91.665l.76 3.947c.53 2.75-.864 4.81-3.908 5.398l-3.22.62c-.845.163-1.5-.28-1.664-1.125L.16 11.772c-.163-.845.28-1.5 1.125-1.664l3.22-.62c3.044-.587 5.106.808 5.635 3.557z"
          />
          <path
            className="transform-origin-center"
            d="M16.985 19.232c.146.847-.35 1.5-1.195 1.648-.848.148-1.515-.305-1.66-1.153L12.333 9.385c-.147-.846.33-1.498 1.175-1.644.867-.15 1.534.31 1.68 1.15l1.795 10.35z"
          />
          <path
            className="transform-origin-center"
            d="M18.282 7.022l6.48-1.016c.752-.117 1.353.356 1.47 1.106.118.752-.315 1.346-1.066 1.463l-1.798.282 1.428 9.11c.133.85-.373 1.495-1.223 1.628-.85.134-1.51-.33-1.643-1.18l-1.427-9.11-1.82.286c-.75.12-1.346-.33-1.464-1.08-.12-.75.31-1.36 1.06-1.48"
          />
          <path
            className="transform-origin-center"
            d="M28.32 5.49l6.5-.882c.755-.1 1.345.384 1.447 1.137.102.754-.343 1.34-1.096 1.44l-1.8.245 1.24 9.137c.12.853-.4 1.488-1.25 1.604-.85.12-1.5-.36-1.61-1.21L30.5 7.82l-1.824.25c-.752.1-1.34-.362-1.442-1.116-.102-.753.34-1.357 1.094-1.46"
          />
          <path
            className="transform-origin-center"
            d="M46.053 11.11l.29 2.766 4.3-.452c.755-.08 1.33.403 1.408 1.16.08.755-.38 1.346-1.13 1.426l-5.77.607c-.85.09-1.47-.41-1.56-1.265L42.51 5.105c-.09-.855.41-1.472 1.266-1.56l5.572-.586c.755-.08 1.328.38 1.407 1.13.08.75-.38 1.36-1.135 1.45l-4.1.43.27 2.58 3.524-.37c.755-.08 1.307.4 1.39 1.16.078.75-.37 1.31-1.125 1.38l-3.53.37z"
          />
          <path
            className="transform-origin-center"
            d="M56.526 4.87l.275 3.388 1.64-.132c1.18-.095 1.84-.81 1.76-1.867-.08-1.02-.85-1.62-2.03-1.52l-1.63.13zm6.81 8.255c.046.097.102.29.115.45.07.8-.57 1.513-1.37 1.578-.6.047-1.15-.31-1.43-.828l-1.95-3.673-1.69.138.27 3.328c.07.857-.48 1.463-1.34 1.532-.85.07-1.48-.44-1.55-1.3l-.84-10.36c-.07-.86.45-1.46 1.3-1.53l3.43-.278c2.61-.213 4.66 1.286 4.86 3.777.14 1.65-.5 2.96-1.64 3.78l1.84 3.38z"
          />
          <path
            className="transform-origin-center"
            d="M73.188 13.048c.046.858-.523 1.45-1.383 1.496-.858.046-1.468-.482-1.513-1.34l-.56-10.487c-.047-.86.502-1.45 1.36-1.495.88-.048 1.49.48 1.535 1.34l.56 10.486z"
          />
          <path
            className="transform-origin-center"
            d="M82.942 3.37l.09 3.398 1.64-.044c1.18-.032 1.88-.71 1.853-1.77-.027-1.02-.764-1.66-1.943-1.628l-1.64.044zm6.352 8.61c.043.1.087.3.09.46.023.8-.66 1.477-1.46 1.498-.598.016-1.128-.37-1.382-.902L84.8 9.262l-1.7.045.09 3.338c.023.86-.56 1.435-1.42 1.457-.86.024-1.455-.52-1.478-1.38L80.014 2.33c-.023-.86.522-1.435 1.38-1.457l3.44-.09c2.618-.07 4.582 1.537 4.648 4.035.044 1.66-.66 2.94-1.842 3.69l1.654 3.476z"
          />
          <path
            className="transform-origin-center"
            d="M95.082 12.44c.007.86-.59 1.426-1.45 1.432-.86.006-1.444-.55-1.45-1.41l-.08-10.5c-.007-.862.57-1.426 1.43-1.432.88-.008 1.464.55 1.47 1.408l.08 10.502z"
          />
          <path
            className="transform-origin-center"
            d="M103.717 3.994c-.353-.784-.85-1.15-1.61-1.156-.96-.01-1.525.505-1.532 1.225-.003.34.13.942 1.128 1.29l1.714.62c1.715.616 3.347 1.472 3.322 3.953-.03 2.4-1.87 4.083-4.67 4.055-2.32-.02-3.99-1.06-4.58-2.8-.27-.84.26-1.88 1.36-1.87.66.01 1.11.37 1.35 1.12.23.73.79 1.15 1.81 1.16 1.22.01 1.86-.56 1.87-1.36 0-.56-.23-1.12-1.09-1.43l-2.06-.76c-1.997-.74-3.02-1.89-3.007-3.79.02-2.04 1.64-3.82 4.38-3.8 2.14.02 3.71 1.02 4.255 2.65.31.95-.3 1.86-1.34 1.85-.64 0-1.095-.41-1.33-.93"
          />
          <path
            className="transform-origin-center"
            d="M111.99 12.656c-.024.86-.64 1.403-1.5 1.38-.858-.025-1.423-.6-1.4-1.46l.29-10.493c.023-.86.618-1.405 1.477-1.38.88.023 1.444.6 1.42 1.46l-.288 10.493z"
          />
          <path
            className="transform-origin-center"
            d="M121.63 6.8l2.58 5.702c.09.204.12.405.11.625-.036.8-.725 1.428-1.544 1.39-.66-.03-1.136-.532-1.335-1l-1.86-4.29-1.62 2.107-.07 1.538c-.04.86-.66 1.392-1.52 1.352-.86-.04-1.41-.625-1.37-1.484l.48-10.486c.04-.86.63-1.392 1.49-1.353.86.04 1.45.63 1.42 1.49l-.21 4.56 3.7-5.17c.28-.39.73-.61 1.21-.58.76.04 1.35.69 1.32 1.44-.01.26-.103.52-.23.7l-2.54 3.47z"
          />
          <path
            className="transform-origin-center"
            d="M129.207 10.477c-.082 1.178.565 1.965 1.723 2.046 1.157.08 1.907-.61 1.99-1.787l.31-4.49c.083-1.178-.564-1.965-1.72-2.046-1.158-.08-1.908.61-1.99 1.787l-.313 4.49zm6.602.52c-.19 2.734-2.23 4.318-5.06 4.12-2.84-.197-4.64-2.046-4.44-4.78l.32-4.61c.19-2.735 1.94-4.338 5.06-4.12 2.83.196 4.63 2.046 4.44 4.78l-.32 4.61z"
          />
          <path
            className="transform-origin-center"
            d="M144.554 6.233c-.285-.81-.75-1.215-1.506-1.285-.957-.09-1.56.377-1.63 1.094-.03.337.053.948 1.017 1.38l1.656.756c1.66.758 3.22 1.747 2.99 4.217-.22 2.39-2.19 3.912-4.98 3.65-2.31-.214-3.88-1.386-4.32-3.174-.2-.86.41-1.85 1.51-1.74.66.06 1.08.47 1.25 1.22.17.74.69 1.21 1.71 1.31 1.22.12 1.91-.4 1.98-1.2.05-.56-.13-1.14-.96-1.51l-1.98-.93c-1.92-.9-2.85-2.13-2.68-4.02.19-2.03 1.95-3.67 4.68-3.42 2.13.2 3.62 1.328 4.02 2.99.23.968-.45 1.83-1.48 1.73-.64-.06-1.06-.5-1.25-1.04"
          />
          <path
            className="transform-origin-center"
            d="M152.058 12.535c-.138 1.172.47 1.99 1.623 2.124 1.16.13 1.94-.52 2.08-1.69l.53-4.47c.14-1.18-.47-1.99-1.62-2.13-1.15-.14-1.93.51-2.07 1.69l-.52 4.47zm6.568.832c-.32 2.722-2.427 4.206-5.25 3.875-2.82-.33-4.526-2.265-4.206-4.986l.54-4.59c.32-2.722 2.15-4.238 5.248-3.874 2.822.332 4.528 2.264 4.208 4.986l-.54 4.59z"
          />
          <path
            className="transform-origin-center"
            d="M170.023 17.944c-.122.852-.736 1.328-1.587 1.207-.594-.08-1.043-.47-1.25-1l-2.798-7.25-.896 6.26c-.11.75-.737 1.19-1.49 1.08-.75-.11-1.23-.7-1.123-1.45l1.51-10.53c.12-.85.79-1.32 1.64-1.2.63.09 1.05.4 1.33 1.12l2.68 6.93.87-6.05c.1-.75.71-1.19 1.46-1.08.75.11 1.25.71 1.14 1.46L170 17.97z"
          />
          <path
            className="transform-origin-center"
            d="M176.52 14.887l-.46 2.742 4.262.71c.75.12 1.174.74 1.048 1.49-.126.75-.73 1.19-1.48 1.07l-5.72-.96c-.848-.15-1.308-.79-1.166-1.64l1.705-10.16c.14-.85.78-1.31 1.63-1.17l5.52.92c.75.13 1.17.722 1.05 1.472-.13.75-.73 1.216-1.48 1.09l-4.07-.683-.43 2.565 3.49.582c.75.13 1.15.74 1.03 1.49-.13.75-.71 1.16-1.46 1.032l-3.49-.59z"
          />
          <path
            className="transform-origin-center"
            d="M192.717 21.98c-.163.843-.8 1.29-1.644 1.128-.588-.113-1.02-.522-1.2-1.067l-2.448-7.37-1.195 6.21c-.145.75-.792 1.15-1.54 1.01-.745-.14-1.197-.76-1.053-1.5l2.013-10.45c.168-.84.86-1.28 1.708-1.11.628.12 1.034.446 1.28 1.186l2.347 7.054 1.16-6.01c.142-.75.77-1.16 1.517-1.01.747.14 1.217.76 1.074 1.51L192.72 22z"
          />
        </Anime>
      </g>
    </svg>
  </div>

export default Logo



// WEBPACK FOOTER //
// ./src/components/Logo/Logo.js